import React, { useState, useEffect } from "react";
import { NavHashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import styles from "../../assets/scss/componnetScss/nav.module.scss";
import { navMenu } from "../../assets/config/config";

export default function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation(); // Get the current path

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Function to add offset before scrolling
  const scrollWithOffset = (el) => {
    const yOffset = -90; // Adjust the offset to 90px before the section
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  };

  return (
    <header className={isScrolled ? styles.scrolled : ""}>
      <div className="container">
        <nav className={`${styles.navbar} ${isScrolled ? styles.navScrolled : ""}`}>
          <div className={styles.logo}>
            <img src="/images/logo.png" alt="SME Electrifier" />
          </div>
          <div className={styles.nav_rt}>
            <ul className={styles.navLinks}>
              {navMenu.map((menu, index) => {
                const isActive = location.pathname + location.hash === menu.url;
                return (
                  <li key={index}>
                    <NavHashLink
                      to={menu.url}
                      smooth
                      scroll={(el) => scrollWithOffset(el)} // Apply custom offset scrolling
                      className={isActive ? styles.active : ""}
                    >
                      {menu.name}
                    </NavHashLink>
                  </li>
                );
              })}
            </ul>
            <button className={styles.contactBtn} onClick={() => (window.location.href = "/contact")}>
              <i className="fa-solid fa-message"></i> Contact us
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
}
